import {
  call, put, takeEvery,
} from 'redux-saga/effects';
import callAdapter from '@/utils/sagaHelper';
import AnnouncementsService from '../service';
import showAnnouncements from '../actions';
import actions from '../constants';

export function* announcements({ category }) {
  const { response } = yield call(callAdapter, AnnouncementsService.announcements());

  if (response) {
    yield put(showAnnouncements(category, response.items));
  }
}

export default function* announcementsApi() {
  yield takeEvery(actions.FETCH_ANNOUNCEMENTS, announcements);
}
